import moment from 'moment';
import React from "react";
import { fetchContract } from '../../api/contracts/actions';
import { CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING, CONTRACT_STATUS_ACTIVE, CONTRACT_STATUS_INACTIVE, CONTRACT_STATUS_WAITING } from '../../constants';
import { formatKennitala, formatMoney, getDescriptiveContractName, getDescriptivePaymentModeName, Tooltip } from '../../utils';
import DetailedContractInfo from "../detailed-contract-info";
import { SvgArrowIcon } from '../svg';


class ContractInfo extends React.Component {
    constructor(props) {
        super(props)

        this.renderTooltip = this.renderTooltip.bind(this)
        this.collapse = this.collapse.bind(this)
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    }

    componentDidMount() {
        this.props.dispatch(fetchContract(this.props.contractId))
    }

    renderTooltip(contractType) {
        if (this.props.tooltips && this.props.tooltips.data.filter(t => t.ax_id === contractType).length > 0) {
            let tooltip = this.props.tooltips.data.filter(t => t.ax_id === contractType)
            return <Tooltip className="xs-ml-10" text={tooltip[0].tooltip_text} />
        }
        return null
    }

    collapse(contractId) {
        let shouldAdd = false
        if ($("#collapse-" + contractId).hasClass('show')) {
            shouldAdd = true
        }
        $("#collapse-" + contractId).collapse('toggle');
        $('.top').addClass('collapsed')
        $("#collapse-control-" + contractId).removeClass('collapsed')
        if (shouldAdd) {
            $("#collapse-control-" + contractId).addClass('collapsed')
        }
    }

    render() {
        let contracts = this.props.contracts;
        let contractInfo = contracts.results.filter((contract) => contract.Contract.ContractId === this.props.contractId)
        if (contractInfo.length > 0) {
            let c = contractInfo[0].Contract

            let contractStatusClassName = '';
            if (CONTRACT_STATUS_ACTIVE.includes(c.ContractStatusId)) {
                contractStatusClassName = 'active'
            } else if (CONTRACT_STATUS_WAITING.includes(c.ContractStatusId)) {
                contractStatusClassName = 'inactive'
            } else if (CONTRACT_STATUS_INACTIVE.includes(c.ContractStatusId)) {
                contractStatusClassName = 'closed'
            }

            let viewType = 'active'
            if (CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                viewType = 'inactive'
            }

            return (
                <>
                    <div className="status-overview-container" >

                        <div className="container-fluid">

                            <div className="row heading">
                                <div className="col-sm-6 col-xs-12 contract-type">
                                    <strong>{getDescriptiveContractName(c.ContractType)}</strong>
                                    {this.renderTooltip(c.ContractType)}
                                </div>
                                <div className="col-sm-6 col-xs-12 contract-status">
                                    <strong>Staða samnings: {c.ContractStatus} <div className={`status-indicator ${contractStatusClassName}`}></div></strong>
                                </div>
                            </div>
                            <div className="row xs-pt-20 xs-pb-20">

                                <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                    <strong>Samningsnúmer</strong><br />
                                    {c.ExternalContractNum}
                                </div>
                                {c.StartDate &&
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                        <strong>Upphafsdagur</strong><br />
                                        {c.StartDate}
                                    </div>
                                }
                                {c.StartDate && !["RIS", "RU", "RUP", "RISU", "RISU60", "RIS60"].includes(c.ContractType) && viewType === 'active' &&
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                        <strong>Samningslok</strong><br />
                                        {moment.utc(c.StartDate, 'DD.MM.YYYY').add(parseInt(c.ContractYears), 'year').format('D.M.YYYY')}
                                    </div>
                                }
                                {!["VID", "VIDE", "VIDT", "VIDTE", "RENE", "FORE"].includes(c.ContractType) && viewType === 'active' &&
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                        <strong>Iðgjald {c.PaymFrequencyTxt.toLowerCase()}</strong><br />
                                        {formatMoney(c.PremiumAmountCur, 2)} €

                                    </div>
                                }
                                {!["VID", "VIDE", "VIDT", "VIDTE", "RENE", "FORE"].includes(c.ContractType) && viewType === 'active' &&
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                        <strong>Greiðsluháttur</strong><br />
                                        {getDescriptivePaymentModeName(c.PaymMode)}
                                    </div>
                                }
                                {!["VID", "VIDE", "VIDT", "VIDTE"].includes(c.ContractType) && viewType === 'active' &&
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                        <strong>Greiðandi</strong><br />
                                        {c.PaymInvoiceName}
                                    </div>
                                }
                                {viewType === 'inactive' &&
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <strong>Tryggingaþegi</strong><br />
                                        {c.CustName} ({formatKennitala(c.CustAccount)})
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="top collapsed" id={"collapse-control-" + c.ContractId}>
                            <div className="arrow" onClick={() => this.collapse(c.ContractId)} aria-expanded="false" aria-controls={"#collapse-" + c.ContractId}>
                                <SvgArrowIcon />
                            </div>
                            <div className="contract-type" onClick={() => this.collapse(c.ContractId)} aria-expanded="false" aria-controls={"#collapse-" + c.ContractId}>Ítarlegri upplýsingar</div>
                        </div>
                    </div>

                    <div id={"collapse-" + c.ContractId} className="collapse contract-detail" data-parent="#accordion-contracts">
                        <DetailedContractInfo viewType={viewType} dispatch={this.props.dispatch} contractId={c.ContractId} contracts={this.props.contracts} olderDeclarations={this.props.olderDeclarations} paymentApplications={this.props.paymentApplications} />
                    </div>
                </>
            )
        } else {
            return <></>
        }
    }
}

export default ContractInfo